export default {
  Red: '#FF0000',
  Cyan: '#00FFFF',
  Blue: '#0000FF',
  'Dark Blue': '#0000A0',
  Pink: '#ff34b7',
  Purple: '#800080',
  Yellow: '#FFFF00',
  Lime: '#00FF00',
  Fuchsia: '#FF00FF',
  Silver: '#C0C0C0',
  Grey: '#808080',
  Black: '#000000',
  Orange: '#F68C34',
  Brown: '#785600',
  'Light Brown': '#af7c00',
  Maroon: '#800000',
  Green: '#008000',
  Tan: '#ffd3a0',
  Olive: '#808000'
};
